import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Stack,
  Card,
  ChoiceList,
  Listbox,
  TextField,
  Checkbox,
  PageActions,
  FormLayout,
  Layout,
  Page,
  DropZone,
  Modal,
  Text,
  Toast,
  List,
  InlineError,
  Thumbnail,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { Editor } from "@tinymce/tinymce-react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import axiosDefault from "axios";
import LoadingScreen from "../../../Components/LoadingScreen";
const AddEditGallery = (props) => {
  const { id, galleryId } = useParams();
  const navigate = useNavigate();
  const slugify = (str) =>
    str
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/[\s_-]+/g, "-")
      .replace(/^-+|-+$/g, "");
  const [isSaving, setIsSaving] = useState(false);
  const handleChangeTitle = (value) => {
    setItem({
      ...item,
      title: value,
      alias: slugify(value),
      seoTitle: slugify(value),
    });
    setTitleError("");
  };
  const [titleError, setTitleError] = useState("");
  const handleChangeAlias = (value) => {
    setItem({ ...item, alias: value });
    setAliasError("");
  };
  const [aliasError, setAliasError] = useState("");
  const handleChangeDescription = (value) => {
    setItem({ ...item, description: value });
  };
  const handleChangeText = (value) => {
    setItem({ ...item, text: value });
  };
  const handleChangeClient = (value) => {
    setItem({ ...item, client: value });
  };
  const handleChangeScopeOfWork = (value) => {
    setItem({ ...item, scopeOfWork: value });
  };
  const handleChangeElectricalConsultant = (value) => {
    setItem({ ...item, electricalConsultant: value });
  };
  const handleChangeMechanicalConsultant = (value) => {
    setItem({ ...item, mechanicalConsultant: value });
  };
  const handleChangeLocation = (value) => {
    setItem({ ...item, location: value });
  };
  const handleChangeDate = (value) => {
    setItem({ ...item, date: value });
  };
  const handleChangeVimeoId = (value) => {
    setItem({ ...item, vimeoId: value });
  };
  const handleChangeMetaTitle = (value) => {
    setItem({ ...item, seoTitle: value });
  };
  const handleChangeMetaDescription = (value) => {
    setItem({ ...item, seoDescription: value });
  };
  const handleChangeChecked = (value) => {
    setItem({ ...item, active: value });
  };
  const handleChangeFeatured = (value) => {
    setItem({ ...item, featured: value });
  };
  const [file, setFile] = useState();
  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFile((file) => acceptedFiles[0]),
    []
  );

  const validImageTypes = [
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/json",
    "image/webp",
  ];
  const fileUpload = !file && (
    <DropZone.FileUpload
      actionHint={"Accepts pngs, jpegs, svgs,webp and jsons"}
    />
  );
  const uploadedFile = file && (
    <Stack>
      <div>
        {file.name}{" "}
        <Text variant="bodySm" as="p">
          {file.size} bytes
        </Text>
      </div>
    </Stack>
  );

  const sendImage = (file) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "portfolio");
    form_data.append("image", file[file.length - 1]);

    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKeySeo.current = result.data.data.file_key;
        setIsImageUploading(false);
        setItem({
          ...item,
          seoImage:
            validImageTypes.indexOf(file[file.length - 1].type) > 0
              ? window.URL.createObjectURL(file[file.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };

  const [filesMain, setFilesMain] = useState();
  const handleDropZoneMain = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesMain((filesMain) => acceptedFiles[0]),
    []
  );
  const fileUploadMain = !filesMain && <DropZone.FileUpload />;
  const uploadedFilesMain = filesMain && (
    <Stack>
      <div className="maxtextwidth">
        {filesMain.name}{" "}
        <Text variant="bodySm" as="p">
          {filesMain.size} bytes
        </Text>
      </div>
    </Stack>
  );
  const [imageError, setImageError] = useState("");

  const imageKey = useRef("");
  const imageKeyMobile = useRef("");
  const imageKeySeo = useRef("");
  const [isImageUploading, setIsImageUploading] = useState(false);
  const sendImageMain = (filesMain) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "portfolio");
    form_data.append("image", filesMain[filesMain.length - 1]);

    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        setItem({
          ...item,
          image:
            validImageTypes.indexOf(filesMain[filesMain.length - 1].type) > 0
              ? window.URL.createObjectURL(filesMain[filesMain.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
        setImageError("");
      })
      .catch(function (error) {});
  };

  const [filesMobile, setFilesMobile] = useState();
  const handleDropZoneMobile = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesMobile((filesMobile) => acceptedFiles[0]),
    []
  );
  const fileUploadMobile = !filesMobile && <DropZone.FileUpload />;
  const uploadedFilesMobile = filesMobile && (
    <Stack>
      <div className="maxtextwidth">
        {filesMobile.name}{" "}
        <Text variant="bodySm" as="p">
          {filesMobile.size} bytes
        </Text>
      </div>
    </Stack>
  );
  const sendImageMobile = (filesMobile) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "portfolio");
    form_data.append("image", filesMobile[filesMobile.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKeyMobile.current = result.data.data.file_key;
        setIsImageUploading(false);
        setItem({
          ...item,
          mobileImage:
            validImageTypes.indexOf(filesMobile[filesMobile.length - 1].type) >
            0
              ? window.URL.createObjectURL(filesMobile[filesMobile.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };
  const [activeToast, setActiveToast] = useState(false);
  const toggleActiveToast = useCallback(
    () => setActiveToast((activeToast) => !activeToast),
    []
  );
  const [toastContent, setToastContent] = useState("");
  const toastMarkup = activeToast ? (
    <Toast content={toastContent} onDismiss={toggleActiveToast} />
  ) : null;
  const [item, setItem] = useState({
    image: "",
    mobileImage: "",
  });
  useEffect(() => {
    props.type === "edit" &&
      axios
        .get(`/portfolios-gallery/${galleryId}`)
        .then((result) => {
          setIsSaving(false);
          setItem({
            image: result?.data?.data?.url ? result.data.data.url : "",
            mobileImage: result?.data?.data?.mobile_url
              ? result.data.data.mobile_url
              : "",
          });
        })
        .catch((err) => console.log(err));
  }, []);
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} Image`}
      breadcrumbs={[
        {
          onAction: () => navigate(`/admin/portfolio/${id}/gallery`),
        },
      ]}
    >
      <FormLayout>
        <Card sectioned>
          <FormLayout.Group>
            <FormLayout>
              <Text as="p" fontWeight="regular">
                Desktop Image
              </Text>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail
                    size="large"
                    source={item.image ? item.image : ""}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone
                    onDrop={handleDropZoneMain}
                    onDropAccepted={sendImageMain}
                    allowMultiple={false}

                    // variableHeight
                  >
                    {uploadedFilesMain}
                    {fileUploadMain}
                  </DropZone>
                </div>
              </div>
              <InlineError message={imageError} />
            </FormLayout>
            <FormLayout>
              <Text as="p" fontWeight="regular">
                Mobile Image
              </Text>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail
                    size="large"
                    source={item.mobileImage ? item.mobileImage : ""}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone
                    onDrop={handleDropZoneMobile}
                    onDropAccepted={sendImageMobile}
                    allowMultiple={false}
                    // variableHeight
                  >
                    {uploadedFilesMobile}
                    {fileUploadMobile}
                  </DropZone>
                </div>
              </div>
            </FormLayout>
          </FormLayout.Group>
        </Card>
      </FormLayout>

      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && [
            {
              content: "Delete",
              destructive: true,
              loading: isSaving && true,
              onClick: () => {
                setIsSaving(true);
                axios
                  .delete(`/portfolios-gallery/${galleryId}`)
                  .then((result) => {
                    navigate(`/admin/portfolio/${id}/gallery`);
                  })
                  .catch((err) => console.log(err));
              },
            },
          ]
        }
      />
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    if (!filesMain && props.type === "add") {
      !filesMain &&
        props.type === "add" &&
        setImageError("The image is required");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      filesMain && form_data.append("image", imageKey.current);
      filesMobile && form_data.append("mobile_image", imageKeyMobile.current);
      // form_data.append("is_active", item.active ? 1 : 0);
      props.type === "edit" && form_data.append("_method", "PATCH");
      form_data.append("portfolio_id", id);
      axios
        .post(
          `/portfolios-gallery${props.type === "edit" ? `/${galleryId}` : ""}`,
          form_data
        )
        .then((res) => {
          if (props.type === "add") {
            navigate(`/admin/portfolio/${id}/gallery`);
          } else {
            setIsSaving(false);
            setToastContent("Changes have been saved succesffully");
            toggleActiveToast();
          }
        })
        .catch((error) => {
          // Error
          if (error.response) {
            setIsSaving(false);
            setAliasError(error.response.data.message);
          } else if (error.request) {
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
        });
    }
  }
};

export default AddEditGallery;
